import PortalIdParser from 'PortalIdParser';
const portalId = PortalIdParser.get();
export const navigateTo = url => {
  if (window.hubspot.wordpress) {
    window.open(url, '_top');
  } else {
    window.location.href = url;
  }
};
const getCampaignsUrl = () => `/marketing/${portalId}/campaigns`;
const getWebsitesUrl = () => `/website/${portalId}/splash`;
export const getTrialGuideUrl = (apiName, source) => {
  return `/trial-guide/${portalId}/${apiName}${source ? `?source=${source}` : ''}`;
};
const trialsWithTrialGuide = ['marketing-hub-professional', 'cms-hub-professional', 'sales-hub-professional', 'service-hub-professional', 'operations-hub-professional', 'marketing-plus-professional-bundle'];
export const handleTrialStartSuccess = ({
  apiName,
  source
}) => {
  var _window$opener;
  if (apiName === 'marketing-plus-enterprise-bundle') {
    navigateTo(getCampaignsUrl());
  } else if (apiName === 'cms-hub-enterprise') {
    navigateTo(getWebsitesUrl());
  } else if (typeof window !== 'undefined' && (_window$opener = window.opener) !== null && _window$opener !== void 0 && _window$opener.location.href) {
    navigateTo(window.opener.location.href);
  } else if (trialsWithTrialGuide.includes(apiName)) {
    navigateTo(getTrialGuideUrl(apiName, source));
  } else {
    window.location.reload();
  }
};
const redirectRoutes = {
  'landing-pages': `/pages/${portalId}/manage/landing`,
  email: `/email/${portalId}/manage`,
  'marketing-workflows': `/workflows/${portalId}`,
  'content-strategy': `/content-strategy/${portalId}/clusters`,
  'sales-workflows': `/workflows/${portalId}`,
  playbooks: `/playbooks/${portalId}`,
  sequences: `/sequences/${portalId}`,
  quotes: `/quotes/${portalId}`,
  tickets: `/contacts/${portalId}/tickets/list/view/all`,
  feedback: `/feedback/${portalId}/home`,
  'knowledge-base': `/knowledge/${portalId}/insights/dashboard`,
  'service-workflows': `/workflows/${portalId}`,
  meetings: `/meetings/${portalId}`,
  'user-settings': `/settings/${portalId}/users?createUserEmail`,
  social: `/social/${portalId}/`,
  seo: `/content-strategy/${portalId}/recommendations`,
  forecasting: `/forecasting/${portalId}`,
  'live-messages-settings': `/live-messages-settings/${portalId}`,
  'custom-coded-workflow-actions': `/workflows/${portalId}`,
  'custom-coded-bot-actions': `/chatflows/${portalId}`,
  webhooks: `/workflows/${portalId}`,
  'data-quality-automation': `/workflows/${portalId}`,
  campaigns: `/marketing/${portalId}/campaigns`,
  datasets: `/advanced-builder/${portalId}/dataset`,
  'snowflake-data-share': `/ecosystem/${portalId}/marketplace/apps/productivity/connector/snowflake`,
  payments: `/settings/${portalId}/sales/payments`
};
export const mapRedirectTargetToRouteFromApiName = (redirectTarget, apiName) => {
  if (redirectTarget !== 'other' && redirectRoutes[redirectTarget]) {
    return redirectRoutes[redirectTarget];
  }
  const hub = apiName ? apiName.split('-')[0] : '';
  return `/reports-dashboard/${portalId}/${hub}`;
};